<div class="showlist-container">
  <!-- 🚫 沒有權限訊息 -->
  <div *ngIf="!hasAnyPermission()" class="no-permission-message">
    <div class="alert alert-warning text-center">
      <i class="fas fa-exclamation-triangle fa-3x mb-3"></i>
      <h4>{{ 'showlist.no_permission_title' | translate }}</h4>
      <p>{{ 'showlist.no_permission_message' | translate }}</p>
    </div>
  </div>

  <!-- ✅ 有權限時顯示正常內容 -->
  <div *ngIf="hasAnyPermission()">
    <!-- Search Panel (Collapsible) -->
    <div class="search-panel-container" *ngIf="showSearchPanel && !showSubform">
    <div class="search-panel-header">
      <h4>{{ 'form.list.search' | translate }}</h4>
      <button class="btn btn-sm btn-outline-secondary close-search-btn"
              (click)="toggleSearchPanel()"
              [title]="'form.list.close_search' | translate">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="search-panel">
      <!-- Add Search Condition Button -->
      <button class="btn btn-primary btn-sm" (click)="addSearchCondition()">
        <i class="fas fa-plus"></i> {{ 'form.list.add_search_condition' | translate }}
      </button>

      <!-- Search Conditions List -->
      <div class="search-conditions" *ngFor="let condition of searchConditions; let i = index">
        <div class="search-condition-row">
          <!-- Field Selection -->
          <select [(ngModel)]="condition.fieldName" (change)="onFieldSelectionChange(i)" class="form-control field-selector">
            <option value="">{{ 'form.list.select_field' | translate }}</option>
            <option *ngFor="let field of searchableFields" [value]="field.name">
              {{ getColumnDisplayName(field.name) }}
            </option>
          </select>

          <!-- Operator Selection -->
          <select [(ngModel)]="condition.operator" class="form-control operator-selector"
                  *ngIf="condition.fieldType !== 'signature' && condition.fieldType !== 'avatar-upload' && condition.fieldType !== 'file-upload-manager'">
            <option *ngFor="let op of getAvailableOperators(condition.fieldType)" [value]="op.value">
              {{ op.label | translate }}
            </option>
          </select>

          <!-- Search Value Input (Dynamically displayed based on field type) -->
          <div class="search-value-container">
            <ng-container [ngSwitch]="condition.fieldType">

              <!-- Text Input -->
              <ng-container *ngSwitchCase="'text-input'">
                <input type="text" [(ngModel)]="condition.value" class="form-control"
                       [placeholder]="'form.list.enter_text' | translate">
              </ng-container>

              <!-- Number Input -->
              <ng-container *ngSwitchCase="'number-input'">
                <input type="number" [(ngModel)]="condition.value" class="form-control"
                       [placeholder]="'form.list.enter_number' | translate">
              </ng-container>

              <!-- Date Selection -->
              <ng-container *ngSwitchCase="'date'">
                <ng-container *ngIf="condition.operator === 'between'; else singleDateInput">
                  <!-- Between operator: two date input fields -->
                  <div class="date-range-container">
                    <input type="date" [(ngModel)]="condition.startValue" class="form-control date-range-start"
                           [placeholder]="'form.list.start_date' | translate">
                    <span class="date-range-separator">~</span>
                    <input type="date" [(ngModel)]="condition.endValue" class="form-control date-range-end"
                           [placeholder]="'form.list.end_date' | translate">
                  </div>
                </ng-container>
                <ng-template #singleDateInput>
                  <!-- Single date input field -->
                  <input type="date" [(ngModel)]="condition.value" class="form-control">
                </ng-template>
              </ng-container>

              <!-- Date Time Selection (only date for search) -->
              <ng-container *ngSwitchCase="'datetime'">
                <ng-container *ngIf="condition.operator === 'between'; else singleDateTimeInput">
                  <!-- Between operator: two date input fields -->
                  <div class="date-range-container">
                    <input type="date" [(ngModel)]="condition.startValue" class="form-control date-range-start"
                           [placeholder]="'form.list.start_date' | translate">
                    <span class="date-range-separator">~</span>
                    <input type="date" [(ngModel)]="condition.endValue" class="form-control date-range-end"
                           [placeholder]="'form.list.end_date' | translate">
                  </div>
                </ng-container>
                <ng-template #singleDateTimeInput>
                  <!-- Single date input field (datetime search only needs date) -->
                  <input type="date" [(ngModel)]="condition.value" class="form-control">
                </ng-template>
              </ng-container>

              <!-- Dropdown -->
              <ng-container *ngSwitchCase="'select'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_option' | translate }}</option>
                  <option *ngFor="let option of getFieldOptions(condition.fieldName)" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </ng-container>

              <!-- Multi-checkbox -->
              <ng-container *ngSwitchCase="'multi-checkbox'">
                <div class="checkbox-search-container">
                  <div *ngFor="let option of getFieldOptions(condition.fieldName)" class="checkbox-item">
                    <label>
                      <input type="checkbox"
                             [checked]="isOptionSelected(condition.value, option.value)"
                             (change)="toggleCheckboxOption(condition, option.value)">
                      {{ option.label }}
                    </label>
                  </div>
                </div>
              </ng-container>

              <!-- Personnel Selector -->
              <ng-container *ngSwitchCase="'personnel-selector'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_personnel' | translate }}</option>
                  <option *ngFor="let user of availableUsers" [value]="user.id">
                    {{ user.name }}
                  </option>
                </select>
              </ng-container>

              <!-- Department Selector -->
              <ng-container *ngSwitchCase="'department-selector'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_department' | translate }}</option>
                  <option *ngFor="let dept of availableDepartments" [value]="dept.id">
                    {{ dept.name }}
                  </option>
                </select>
              </ng-container>

              <!-- Approval Status -->
              <ng-container *ngSwitchCase="'approval-flow'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_approval_status' | translate }}</option>
                  <option value="pending">{{ 'approval.status.pending' | translate }}</option>
                  <option value="rejected">{{ 'approval.status.rejected' | translate }}</option>
                  <option value="completed">{{ 'approval.status.completed' | translate }}</option>
                </select>
              </ng-container>

              <!-- Approval Personnel Selector Status -->
              <ng-container *ngSwitchCase="'approval-personnel-selector'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_approval_status' | translate }}</option>
                  <option value="pending">{{ 'approval.status.pending' | translate }}</option>
                  <option value="rejected">{{ 'approval.status.rejected' | translate }}</option>
                  <option value="completed">{{ 'approval.status.completed' | translate }}</option>
                </select>
              </ng-container>

              <!-- Status Field -->
              <ng-container *ngSwitchCase="'status'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_status' | translate }}</option>
                  <option value="active">{{ 'form.list.status_active' | translate }}</option>
                  <option value="draft">{{ 'form.list.status_draft' | translate }}</option>
                  <option value="in_progress">{{ 'form.list.status_in_progress' | translate }}</option>
                  <option value="approved">{{ 'form.list.status_approved' | translate }}</option>
                  <option value="disabled">{{ 'form.list.status_disabled' | translate }}</option>
                </select>
              </ng-container>

              <!-- Signature Field -->
              <ng-container *ngSwitchCase="'signature'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_signature_status' | translate }}</option>
                  <option value="true">{{ 'signature.status.has_signature' | translate }}</option>
                  <option value="false">{{ 'signature.status.no_signature' | translate }}</option>
                </select>
              </ng-container>

              <!-- Avatar Upload Field -->
              <ng-container *ngSwitchCase="'avatar-upload'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_avatar_status' | translate }}</option>
                  <option value="true">{{ 'avatar.status.has_avatar' | translate }}</option>
                  <option value="false">{{ 'avatar.status.no_avatar' | translate }}</option>
                </select>
              </ng-container>

              <!-- File Upload Manager Field -->
              <ng-container *ngSwitchCase="'file-upload-manager'">
                <select [(ngModel)]="condition.value" class="form-control">
                  <option value="">{{ 'form.list.select_file_status' | translate }}</option>
                  <option value="true">{{ 'file.status.has_files' | translate }}</option>
                  <option value="false">{{ 'file.status.no_files' | translate }}</option>
                </select>
              </ng-container>

              <!-- Default Text Input -->
              <ng-container *ngSwitchDefault>
                <input type="text" [(ngModel)]="condition.value" class="form-control"
                       [placeholder]="'form.list.enter_search_value' | translate">
              </ng-container>

            </ng-container>
          </div>

          <!-- Remove Condition Button -->
          <button class="btn btn-sm btn-outline-danger" (click)="removeSearchCondition(i)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <!-- Search Control Buttons -->
      <div class="search-actions">
        <button class="btn btn-primary" (click)="performSearch()">
          <i class="fas fa-search"></i> {{ 'form.list.search' | translate }}
        </button>
        <button class="btn btn-primary" (click)="clearSearch()">
          <i class="fas fa-times"></i> {{ 'form.list.clear_search' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Title Row and Add Button -->
  <div class="header-section" *ngIf="!showSubform">
    <div class="title-section">
      <h3>{{formName}}</h3>
      <!-- Form Info Button -->
      <button class="form-info-btn"
              (click)="showFormInfo()"
              [title]="'form.list.form_info' | translate">
        <i class="fas fa-info-circle"></i>
      </button>
      <!-- Column Settings Button -->
      <button class="column-settings-btn"
              *ngIf="!shouldHideColumnSettings()"
              (click)="openColumnSettings()"
              [title]="'form.list.column_settings' | translate">
        <i class="fas fa-columns"></i>
      </button>
      <!-- Refresh Button -->
      <button class="refresh-btn"
              (click)="refreshData()"
              [disabled]="isRefreshing"
              [title]="'form.list.refresh_data' | translate">
        <i class="fas fa-sync-alt" [class.fa-spin]="isRefreshing"></i>
      </button>
      <!-- Search Toggle Button -->
      <button class="search-toggle-btn"
              (click)="toggleSearchPanel()"
              [class.active]="showSearchPanel"
              [title]="showSearchPanel ? ('form.list.close_search' | translate) : ('form.list.open_search' | translate)">
        <i class="fas" [class.fa-search]="!showSearchPanel" [class.fa-times]="showSearchPanel"></i>
      </button>
    </div>

    <!-- Right Side Action Area -->
    <div class="actions-section">
      <!-- Sort Selector - 暫時隱藏 -->
      <div class="sort-selector" *ngIf="false">
        <label>{{ 'form.list.sort_by' | translate }}:</label>
        <select [(ngModel)]="sortBy" (ngModelChange)="changeSortBy($event)" class="form-control">
          <option value="_ts">{{ 'form.list.sort_modified_time' | translate }}</option>
          <option value="createdAt">{{ 'form.list.sort_created_time' | translate }}</option>
        </select>
        <button class="sort-order-btn"
                (click)="toggleSortOrder()"
                [title]="sortOrder === 'desc' ? ('form.list.sort_desc' | translate) : ('form.list.sort_asc' | translate)">
          <i class="fas" [class.fa-sort-amount-down]="sortOrder === 'desc'" [class.fa-sort-amount-up]="sortOrder === 'asc'"></i>
        </button>
      </div>

      <!-- Items Per Page Selector -->
      <div class="page-size-selector" *ngIf="!showSubform && !isLoading && filteredData.length > 0">
        <label>{{ 'pagination.items_per_page' | translate }}:</label>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)" class="form-control">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
        </select>
      </div>

      <!-- Total Data Count -->
      <div class="total-count-display">
        <span class="count-label">{{ 'form.list.total_records' | translate }}:</span>
        <span class="count-number">{{ getTotalRecordsCount() }}</span>
      </div>

      <!-- Add Button -->
      <button *ngIf="hasCreatePermission()" class="btn btn-primary add-record-btn" (click)="createNewRecord()" title="{{ 'form.list.add_record' | translate }}">
        <i class="fas fa-plus"></i> {{ 'common.add' | translate }}
      </button>
    </div>
  </div>

  <!-- Table View - Raw Data -->
  <div class="table-wrapper" *ngIf="!showSubform">
    <!-- Display table when data is available -->

    <table class="table" *ngIf="!isLoading && filteredData.length > 0">
      <thead>
        <tr>
            <th *ngIf="hasEditPermission() || hasDeletePermission() || hasWithdrawPermission() || hasDisablePermission()" class="actions-column">{{ 'form.list.actions' | translate }}</th>
            <!-- 🆕 待辦事項獨立欄位標題 -->
            <th *ngIf="showTodoIndicator" class="todo-column">{{ 'common.todo' | translate }}</th>
            <th class="status-column">{{ 'form.list.status' | translate }}</th>
            <th *ngIf="enableCloseButton" class="close-column">{{ 'showlist.close_case' | translate }}</th>
            <th *ngIf="customActionButtons" class="custom-actions-column">{{ 'form.list.custom_actions' | translate }}</th>
          <th *ngFor="let column of displayedColumns">
            {{ getColumnDisplayName(column) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of paginatedData" [class.disabled]="item.deleted">
           <td *ngIf="hasEditPermission() || hasDeletePermission() || hasWithdrawPermission() || hasDisablePermission()" class="actions-column">
            <div class="action-buttons">
              <button class="action-btn view-btn"
                (click)="viewItem(item)"
                [title]="'form.list.view_details' | translate">
                <i class="fas fa-eye"></i>
                <!-- <span>{{ 'form.list.view' | translate }}</span> -->
              </button>
              <button *ngIf="hasEditPermission()"
                class="action-btn edit-btn"
                (click)="editItem(item)"
                [title]="canEditItem(item) ? ('common.edit' | translate) : getEditBlockedReason(item)"
                [disabled]="isLoading || !canEditItem(item)"
                [class.disabled]="!canEditItem(item)">
                <i class="fas fa-edit"></i>
                <!-- <span>{{ 'common.edit' | translate }}</span> -->
              </button>
              <button *ngIf="hasDeletePermission()"
                class="action-btn abolish-btn"
                (click)="abolishItem(item)"
                [title]="item.deleted ? ('form.list.already_abolished' | translate) : ('form.list.abolish' | translate)"
                [disabled]="isLoading || item.deleted"
                [class.disabled]="item.deleted">
                <i class="fas fa-ban"></i>
                <!-- <span>{{ 'form.list.abolish' | translate }}</span> -->
              </button>
              <button *ngIf="hasDeletePermission() && !hideDeleteButton"
                class="action-btn delete-btn"
                (click)="deleteItem(item)"
                [title]="canDeleteItem(item) ? ('common.delete' | translate) : getDeleteBlockedReason(item)"
                [disabled]="isLoading || !canDeleteItem(item)"
                [class.disabled]="!canDeleteItem(item)">
                <i class="fas fa-trash"></i>
                <!-- <span>{{ 'common.delete' | translate }}</span> -->
              </button>
              <button *ngIf="hasWithdrawPermission() && hasApprovalFlowInItem(item)"
                class="action-btn withdraw-btn"
                (click)="withdrawItem(item)"
                [title]="getWithdrawTooltip(item)"
                [disabled]="isLoading || !canWithdrawItem(item)"
                [class.disabled]="!canWithdrawItem(item)">
                <i class="fas fa-reply"></i>
                <!-- <span>{{ 'form.list.withdraw' | translate }}</span> -->
              </button>
              <button *ngIf="hasDisablePermission()"
                class="action-btn disable-btn"
                (click)="disableItem(item)"
                [title]="canDisableItem(item) ? ('form.list.disable' | translate) : getDisableBlockedReason(item)"
                [disabled]="isLoading || !canDisableItem(item)"
                [class.disabled]="!canDisableItem(item)">
                <i class="fas fa-times-circle"></i>
                <!-- <span>{{ 'form.list.disable' | translate }}</span> -->
              </button>
            </div>
          </td>
          <!-- 🆕 待辦事項獨立欄位資料 -->
          <td *ngIf="showTodoIndicator" class="todo-column">
            <div class="todo-badge-wrapper">
              <div class="todo-badge"
                   [class.todo-badge-has-items]="getTodoCount(item) > 0"
                   [class.todo-badge-completed]="getTodoCount(item) === 0"
                   (click)="onTodoBadgeClick(item, $event)"
                   [title]="getTodoTooltip(item)">
                <!-- 有待辦：顯示紅色數字 -->
                <ng-container *ngIf="getTodoCount(item) > 0">
                  <span class="todo-count">{{ getTodoCount(item) }}</span>
                </ng-container>
                <!-- 已完成：顯示綠色勾勾 -->
                <ng-container *ngIf="getTodoCount(item) === 0">
                  <i class="fas fa-check todo-check-icon"></i>
                </ng-container>
              </div>
            </div>
          </td>
          <td class="status-column">
            <span [class]="'status-badge ' + getItemStatus(item)"
                  [title]="getItemStatus(item) === 'abolished' ? '廢止原因：' + getAbolishReason(item) : ''">
              {{ getStatusLabel(getItemStatus(item)) }}
            </span>
          </td>
          <td *ngIf="enableCloseButton" class="close-column">
            <button *ngIf="shouldShowCloseButton(item)"
              class="btn btn-sm close-item-btn"
              (click)="closeItem(item)"
              [title]="getCloseButtonTooltip(item)"
              [disabled]="isLoading || isCloseButtonDisabled(item)">
              <i class="fas fa-check-circle"></i>
              {{ 'form.list.close' | translate }}
            </button>
          </td>
          <!-- 🆕 自定義操作按鈕欄位 -->
          <td *ngIf="customActionButtons" class="custom-actions-column">
            <div class="custom-action-buttons">
              <ng-container *ngFor="let button of getCustomButtons(item)">
                <button *ngIf="button.show !== false"
                  class="btn btn-sm"
                  [class]="'action-btn ' + (button.class || '')"
                  (click)="button.onClick(item)"
                  [title]="button.title || ''"
                  [disabled]="isLoading || button.disabled">
                  <i *ngIf="button.icon" [class]="button.icon"></i>
                  {{ button.label }}
                </button>
              </ng-container>
            </div>
          </td>
          <td *ngFor="let column of displayedColumns">
            <ng-container *ngIf="item[column] && item[column].value !== undefined; else directDisplay">
              <ng-container [ngSwitch]="item[column].type">

                <ng-container *ngSwitchCase="'location'">
                  <div class="center-align location">
                    <!-- Handle string format location information -->
                    <ng-container *ngIf="isNonEmptyString(item[column].value)">
                      <a [href]="getGoogleMapsUrl(item[column].value)" target="_blank" title="Open Google Map">
                        <i class="fa-solid fa-location-dot"></i>
                      </a>
                    </ng-container>
                    <!-- Handle object format location information -->
                    <ng-container *ngIf="hasValidLocationData(item[column].value)">
                      <a [href]="getGoogleMapsUrl(item[column].value.originalValue)" target="_blank" title="Open Google Map">
                        <i class="fa-solid fa-location-dot"></i>
                      </a>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'photo-upload'">
                  <div *ngFor="let photo of parsePhotos(item[column].value)" class="thumbnail">
                    <a [href]="photo.fileUrl" target="_blank" rel="noopener noreferrer">
                      <img [src]="photo.fileUrl" [alt]="photo.fileName" style="width:50px; height:50px; margin-right:4px; cursor:pointer;"
                           (error)="onPhotoImageError(photo, $event)">
                    </a>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'avatar-upload'">
                  <div class="avatar-display" [ngClass]="'display-' + getAvatarDisplayMode(item[column])" *ngIf="getAvatarData(item[column])">
                    <img [src]="getAvatarImageUrl(item[column])"
                         [alt]="'Avatar'"
                         class="avatar-thumbnail clickable"
                         (click)="viewImageFullSize(getAvatarImageUrl(item[column]))"
                         (error)="onAvatarImageError(item, column, $event)"
                         [title]="getAvatarFileName(item[column])">
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'signature'">
                  <!-- Only display when there is signature data and value is not empty -->
                  <ng-container *ngIf="hasValidSignatureData(item[column].value)">
                    <div class="signature-container">
                      <!-- Display signature image and summary -->
                      <div class="signature-display">
                        <img [src]="getSignatureImageData(item[column].value)" alt="Signature" class="signature-thumbnail"
                             [title]="getSignatureColumnTooltip(item[column])">
                        <div class="signature-info">
                          <small class="signature-summary">{{ getSignatureSummary(item[column]) }}</small>
                          <small class="signed-date" *ngIf="getSignatureDate(item[column])">
                            {{ getSignatureDate(item[column]) }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'multi-checkbox'">
                  {{ getMultiCheckboxSelectedText(item[column].value) }}
                </ng-container>

                <ng-container *ngSwitchCase="'datetime'">
                  <ng-container *ngIf="item[column].value && item[column].value !== '' && convertUnixToLocal(item[column].value) !== null; else emptyDateTime">
                    {{ convertUnixToLocal(item[column].value) | date:'yyyy-MM-dd HH:mm:ss' }}
                  </ng-container>
                  <ng-template #emptyDateTime>
                    <!-- Do not display anything when value is empty -->
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'date-range'">
                  <ng-container *ngIf="item[column].value && item[column].value.startDate && item[column].value.endDate; else emptyDateRange">
                    {{ formatDateRange(item[column].value) }}
                  </ng-container>
                  <ng-template #emptyDateRange>
                    <!-- Do not display anything when value is empty -->
                  </ng-template>
                </ng-container>

                <!-- Subform -->
                <ng-container *ngSwitchCase="'subform-relation'">
                  <!-- 🔑 優化：使用 Map 直接取值，避免重複呼叫函數 -->
                  <ng-container *ngIf="item[column].value && item.id">
                    <div class="subform-relation-display clickable"
                         (click)="loadSubform(item[column].value, item, column)"
                         [title]="'form.subform.click_to_view' | translate"
                         [class]="getSubformCssClass ? getSubformCssClass(item, column) : ''">
                      <!-- <i class="fas fa-link"></i> -->
                      <span class="subform-info">
                        <!-- <span class="subform-id">{{ item[column].value }}</span> -->
                        <span class="subform-count">{{ subformCountMap.get(getFormIdFromValue(item[column].value) + '|' + item.id) || 0 }} {{ 'common.records' | translate }}</span>
                      </span>
                      <!-- <i class="fas fa-external-link-alt view-icon"></i> -->
                    </div>
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'file-upload-manager'">
                  <ng-container *ngIf="getFileManagerFiles(item[column]?.value) as files">
                    <div *ngIf="files.length > 0; else noFiles" class="file-manager-display">

                      <!-- Single file: directly display view button -->
                      <div *ngIf="files.length === 1">
                        <button class="btn btn-sm btn-outline-primary file-view-btn"
                                (click)="viewFile(files[0])"
                                [title]="files[0]?.name">
                          <i class="fas fa-file"></i> {{ 'form.list.view_file' | translate }}
                        </button>
                      </div>

                      <!-- Multiple files: display file count button -->
                      <div *ngIf="files.length > 1">
                        <button class="btn btn-sm btn-outline-primary file-view-btn"
                                (click)="openFilesModal(files, item, column)"
                                [title]="'form.list.view_files_count' | translate: {count: files.length}">
                          <i class="fas fa-folder"></i>
                          {{ 'form.list.view_file' | translate }}
                          <span class="file-count-badge">{{ files.length }}</span>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noFiles>
                    <!-- Empty display -->
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'required-document-upload'">
                  <div *ngIf="getRequiredDocumentFile(item[column].value); else noRequiredFile" class="required-document-display">
                    <div class="file-download-section">
                      <button type="button"
                              class="btn btn-sm btn-outline-primary file-download-btn"
                              (click)="downloadRequiredDocument(item, column)"
                              [disabled]="isDownloadingDocument[getDocumentKey(item, column)]"
                              [title]="getRequiredDocumentFile(item[column].value)?.name">
                        <i class="fas" [class.fa-eye]="!isDownloadingDocument[getDocumentKey(item, column)]"
                                       [class.fa-sync-alt]="isDownloadingDocument[getDocumentKey(item, column)]"
                                       [class.fa-spin]="isDownloadingDocument[getDocumentKey(item, column)]"></i>
                        {{ isDownloadingDocument[getDocumentKey(item, column)] ? ('common.processing' | translate) : ('common.view_file' | translate) }}
                      </button>
                    </div>
                    <div class="file-info" *ngIf="getRequiredDocumentFile(item[column].value)?.name">
                      <small class="file-name text-muted">{{ getRequiredDocumentFile(item[column].value)?.name }}</small>
                    </div>
                    <div class="ai-response-section" *ngIf="getRequiredDocumentAIResponse(item[column].value)">
                      <small class="ai-response-text">{{ getRequiredDocumentAIResponse(item[column].value) }}</small>
                    </div>
                  </div>
                  <ng-template #noRequiredFile>
                    <!-- Display blank when no file -->
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'audio-recorder'">
                  <div *ngIf="item[column].value?.fileName; else noAudio" class="audio-recorder-display">
                    <div class="audio-info">
                      <i class="fas fa-microphone"></i>
                      <span class="audio-filename">{{ item[column].value?.fileName || 'audio-recording' }}</span>
                      <span *ngIf="item[column].value?.duration" class="audio-duration">
                        ({{ item[column].value.duration }}s)
                      </span>
                    </div>

                    <!-- If there is a valid audio URL, display playback controls -->
                    <div *ngIf="item[column].value?.previewUrl || (item[column].value?.fileUrl && !item[column].value?.fileUrl.startsWith('blob:')); else audioUnavailable" class="audio-controls">
                      <audio [src]="item[column].value.previewUrl || item[column].value.fileUrl"
                             controls
                             preload="metadata"
                             (error)="onAudioError(item, column, $event)"
                             style="max-width: 200px;">
                        {{ 'audio.browser_not_supported' | translate }}
                      </audio>
                    </div>

                    <!-- Handle when audio is unavailable -->
                    <ng-template #audioUnavailable>
                      <div class="audio-status">
                        <div *ngIf="item[column].value?.blobName; else noBlob" class="audio-retry">
                          <button class="btn btn-sm btn-outline-primary"
                                  (click)="regenerateAudioUrl(item, column)"
                                  [disabled]="isRegeneratingAudio[getAudioKey(item, column)]">
                            <i class="fas fa-sync-alt" [class.fa-spin]="isRegeneratingAudio[getAudioKey(item, column)]"></i>
                            {{ 'audio.reload' | translate }}
                          </button>
                        </div>
                        <ng-template #noBlob>
                          <div class="audio-unavailable">
                            <i class="fas fa-exclamation-triangle text-warning"></i>
                            <span>{{ 'audio.file_unavailable' | translate }}</span>
                          </div>
                        </ng-template>
                      </div>
                    </ng-template>
                  </div>
                  <ng-template #noAudio>
                    <!-- Display blank when no recording -->
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'tags'">
                  <div class="tags-display">
                    <div class="mb-2">
                      <small>{{ item[column].value?.join(', ') }}</small>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'dynamic-api-table'">
                  <div class="dynamic-api-table-display clickable"
                       (click)="openDynamicApiTableDialog(item[column].value, getColumnDisplayName(column))"
                       [title]="'form.list.click_to_view_data' | translate">
                    <span class="data-count">
                      <i class="fas fa-table"></i>
                      {{ getDynamicApiTableCount(item[column].value) }} {{ 'common.records' | translate }}
                    </span>
                    <!-- <i class="fas fa-external-link-alt view-icon"></i> -->
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'dynamic-api-select'">
                  <div class="dynamic-api-select-display">
                    <span class="selected-value">
                      <i class="fas fa-list-ul"></i>
                      {{ getDynamicApiSelectDisplayValue(item[column]) }}
                    </span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'department-selector'">
                  {{ getDepartmentSelectorDisplayValue(item[column]) }}
                </ng-container>

                <ng-container *ngSwitchCase="'approval-flow'">
                  <app-approval-flow-display
                    [steps]="convertToApprovalFlowSteps(item[column])"
                    [compact]="true"
                    [showLabels]="false"
                    [enableStepClick]="!hasTodoItems(item)"
                    [currentUserId]="currentUserId"
                    [formId]="item.formid"
                     [id]  ="item.id"
                    [formName]="formName"
                    [approvalFlow]="getApprovalFlowData(item[column])"
                    [deleted]="item.deleted"
                    (approvalComplete)="onApprovalComplete($event)">
                  </app-approval-flow-display>
                </ng-container>

                <ng-container *ngSwitchCase="'approval-personnel-selector'">
                  <app-approval-flow-display
                    [steps]="convertToApprovalFlowSteps(item[column])"
                    [compact]="true"
                    [showLabels]="false"
                    [enableStepClick]="!hasTodoItems(item)"
                    [currentUserId]="currentUserId"
                    [formId]="item.formid"
                     [id]  ="item.id"
                    [formName]="formName"
                    [approvalFlow]="getApprovalFlowData(item[column])"
                    [deleted]="item.deleted"
                    (approvalComplete)="onApprovalComplete($event)">
                  </app-approval-flow-display>
                </ng-container>

                <ng-container *ngSwitchCase="'meeting-signature-collection'">
                  <!-- 只有當有簽名資料時才顯示 -->
                  <ng-container *ngIf="hasValidMeetingSignatureData(item[column].value)">
                    <div class="meeting-signature-display clickable"
                         (click)="openMeetingSignatureDialog(item[column].value, getColumnDisplayName(column))"
                         [title]="'meeting.signature.click_to_view' | translate">
                      <i class="fas fa-users"></i>
                      <span class="signature-count">{{ getMeetingSignatureCount(item[column].value) }}</span>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'risk-assessment-matrix'">
                  <div class="risk-assessment-matrix-display">
                    <div class="risk-matrix-result">
                      <div class="risk-level"
                           [class]="'risk-level-' + getRiskLevelClass(item[column].value?.riskLevel)">
                        <i class="fas fa-chart-area"></i>
                        <span class="risk-level-text">{{ item[column].value?.riskLevel || ('common.not_calculated' | translate) }}</span>
                      </div>
                      <div class="risk-score" *ngIf="item[column].value?.calculatedResult !== undefined">
                        <small>{{ 'form.risk_matrix.score' | translate }}: {{ item[column].value.calculatedResult }}</small>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'video-player'">
                  <div class="video-player-display" *ngIf="item[column].value && item[column].value.youtubeUrl">
                    <div class="video-info">
                      <i class="fab fa-youtube"></i>
                      <span class="video-title">{{ item[column].value.videoTitle || ('video.youtube_video' | translate) }}</span>
                    </div>
                    <div class="video-url">
                      <a [href]="item[column].value.youtubeUrl" target="_blank" class="video-link">
                        <i class="fas fa-external-link-alt"></i>
                        {{ 'video.open_youtube' | translate }}
                      </a>
                    </div>
                  </div>
                  <div *ngIf="!item[column].value || !item[column].value.youtubeUrl" class="video-empty">
                    <i class="fas fa-video-slash"></i>
                    <span>{{ 'video.no_video' | translate }}</span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'number-input'">
                  {{ formatNumberInput(item[column].value) }}
                </ng-container>

                <ng-container *ngSwitchCase="'radiobutton'">
                  <div class="radiobutton-display">
                    <!-- Main selected value -->
                    <span class="selected-value">
                      {{ getRadiobuttonSelectedValue(item[column].value) }}
                    </span>

                    <!-- Conditional data indicators -->
                    <span class="conditional-indicators" *ngIf="hasRadiobuttonConditionalData(item[column].value)">
                      <!-- Remarks indicator -->
                      <i class="fas fa-comment-alt conditional-icon remarks-icon"
                         *ngIf="item[column].value?.conditionalData?.remarks"
                         [title]="('radiobutton.indicators.remarks' | translate) + ': ' + item[column].value.conditionalData.remarks"
                         (click)="showRadiobuttonDetails(item, column)"></i>

                      <!-- Image upload indicator -->
                      <i class="fas fa-image conditional-icon image-icon"
                         *ngIf="item[column].value?.conditionalData?.uploadedFiles && item[column].value.conditionalData.uploadedFiles.length > 0"
                         [title]="('radiobutton.indicators.uploaded_files' | translate) + ': ' + item[column].value.conditionalData.uploadedFiles.length + ' ' + ('common.file_count' | translate)"
                         (click)="showRadiobuttonDetails(item, column)"></i>

                      <!-- Audio recording indicator -->
                      <i class="fas fa-microphone conditional-icon audio-icon"
                         *ngIf="item[column].value?.conditionalData?.audioRecording"
                         [title]="('radiobutton.indicators.audio_recording' | translate) + ': ' + item[column].value.conditionalData.audioRecording?.fileName"
                         (click)="showRadiobuttonDetails(item, column)"></i>
                    </span>
                  </div>
                </ng-container>

                <!-- Timestamp -->
                <ng-container *ngSwitchCase="'timestamp'">
                  <div class="timestamp-display">
                    {{ formatTimestamp(item[column].value.value) }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{ getDisplayValue(item[column].value) }}
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #directDisplay>
              <!-- Special handling for referencedata field -->
              <ng-container *ngIf="column === 'referencedata' && item[column]; else normalDisplay">
                <div class="reference-data-display clickable"
                     (click)="openReferenceDataDialog(item[column])"
                     [title]="'showlist.click_to_view_reference_data' | translate">
                  <i class="fas fa-clipboard-list"></i>
                  <span class="reference-count">{{ getReferenceDataCount(item[column]) }} {{ 'common.items' | translate }}</span>
                </div>
              </ng-container>

              <ng-template #normalDisplay>
                <!-- Special handling for expanded referencedata field -->
                <ng-container *ngIf="column.startsWith('referencedata_'); else regularDisplay">
                  <span>{{ getReferenceDataValue(item, column) }}</span>
                </ng-container>

                <ng-template #regularDisplay>
                  <ng-container [ngSwitch]="isDateColumn(column)">
                    <span *ngSwitchCase="true">{{ formatDate(item[column]) }}</span>
                    <span *ngSwitchDefault>{{ getDirectDisplayValue(item[column], column) }}</span>
                  </ng-container>
                </ng-template>
              </ng-template>
            </ng-template>
          </td>

        </tr>
      </tbody>
    </table>

    <!-- Loading display message -->
    <div class="loading-container" *ngIf="isLoading">
      <div class="loading-content">
        <i class="fas fa-spinner fa-spin loading-spinner"></i>
        <span class="loading-text">{{ 'common.loading' | translate }}</span>
      </div>
    </div>

    <!-- No data display message (only shown when loading is complete and there is indeed no data) -->
    <div class="no-data-container" *ngIf="!isLoading && hasLoadedOnce && filteredData.length === 0">
      <div class="no-data-content">
        <i class="fas fa-info-circle"></i>
        <span>{{ 'form.list.no_data_available' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Pagination Controller - Bottom -->
  <div class="pagination-wrapper bottom" *ngIf="!showSubform && !isLoading && filteredData.length > 0 && totalPages > 1">
    <!-- Pagination Navigation - Centered -->
    <div class="pagination-navigation">
      <button class="pagination-btn"
              (click)="firstPage()"
              [disabled]="currentPage === 1"
              [title]="'pagination.first_page' | translate">
        <i class="fas fa-angle-double-left"></i>
      </button>

      <button class="pagination-btn"
              (click)="previousPage()"
              [disabled]="currentPage === 1"
              [title]="'pagination.previous_page' | translate">
        <i class="fas fa-angle-left"></i>
      </button>

      <div class="page-numbers">
        <button *ngFor="let pageNum of getPageNumbers()"
                class="pagination-btn page-number"
                [class.active]="pageNum === currentPage"
                (click)="goToPage(pageNum)">
          {{ pageNum }}
        </button>
      </div>

      <button class="pagination-btn"
              (click)="nextPage()"
              [disabled]="currentPage === totalPages"
              [title]="'pagination.next_page' | translate">
        <i class="fas fa-angle-right"></i>
      </button>

      <button class="pagination-btn"
              (click)="lastPage()"
              [disabled]="currentPage === totalPages"
              [title]="'pagination.last_page' | translate">
        <i class="fas fa-angle-double-right"></i>
      </button>
    </div>
  </div>

  <!-- Subform Display Area -->
  <div *ngIf="showSubform" id="subform-container" class="subform-container">
    <div class="subform-header">
      <div class="subform-title">
        <i class="fas fa-link"></i>
        <span>{{ 'form.subform.viewing' | translate }}</span>
        <span class="subform-title-text">{{ subformDisplayTitle }}</span>
      </div>
      <button class="close-subform-button" (click)="closeSubform()" [title]="'form.subform.close' | translate">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="subform-content">
      <app-showlist
        *ngIf="showSubform"
        [formId]="subformId"
        [formName]="subformName"
        [parentFormId]="currentParentFormId"
        [parentDateRange]="parentDateRange"
        (dataUpdated)="onSubformDataUpdated()">
      </app-showlist>
    </div>
  </div>

</div>

<!-- Edit Form Dialog - Using Dynamic Form -->
<div *ngIf="showEditDialog" class="form-dialog-overlay">
  <div class="form-dialog">
    <div class="dialog-header">
      <h3>{{ 'form.list.edit_record' | translate }}</h3>
      <button class="close-button" (click)="closeEditDialog()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <div *ngIf="editFormConfig.length === 0" class="no-editable-fields">
        <i class="fas fa-info-circle"></i>
        <p>{{ 'form.list.no_editable_fields' | translate }}</p>
      </div>

      <!-- Use Dynamic Form component for editing -->
      <app-dynamic-form
        *ngIf="editFormConfig.length > 0"
        [formName]="formName + '_edit'"
        [config]="editFormConfig"
        [formid]="formId"
        [parent_formid]="editingItem?.parent_formid || parentFormId"
        [preview]="false"
        [editMode]="true"
        [editFormId]="editingItem?.id"
        [initialValues]="editingItemData"
        (recordAdded)="handleEditComplete($event)"
        (formCancelled)="closeEditDialog()">
      </app-dynamic-form>
    </div>
  </div>
</div>

<!-- Disable Confirmation Dialog -->
<div *ngIf="showDisableConfirm" class="confirm-dialog-overlay">
  <div class="confirm-dialog">
    <div class="dialog-header">
      <h3>{{ 'form.list.confirm_disable' | translate }}</h3>
      <button class="close-button" (click)="closeDisableConfirm()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content">
      <div class="confirm-message">
        <i class="fas fa-exclamation-circle warning-icon"></i>
        <p>{{ 'form.list.disable_warning' | translate }}</p>
      </div>

      <!-- 🆕 無効理由入力欄（承認コメントと同じパターン） -->
      <div class="form-group">
        <label for="disableComment">
          {{ 'form.list.disable_reason' | translate }}
          <span class="required">*</span>
        </label>
        <textarea
          id="disableComment"
          [(ngModel)]="disableComment"
          rows="4"
          class="form-control"
          [disabled]="isLoading"
          [placeholder]="'form.list.disable_reason_placeholder' | translate"
          required>
        </textarea>
      </div>

      <div class="dialog-buttons">
        <button class="cancel-button" (click)="closeDisableConfirm()" [disabled]="isLoading">
          {{ 'form.list.cancel' | translate }}
        </button>
        <button 
          class="confirm-button" 
          (click)="confirmDisable()" 
          [disabled]="isLoading || !disableComment || disableComment.trim() === ''">
          <span *ngIf="isLoading">{{ 'form.list.disabling' | translate }}</span>
          <span *ngIf="!isLoading">{{ 'form.list.confirm_disable_button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Withdraw Confirmation Dialog -->
<div *ngIf="showWithdrawConfirm" class="confirm-dialog-overlay">
  <div class="confirm-dialog">
    <div class="dialog-header">
      <h3>{{ 'form.list.confirm_withdraw' | translate }}</h3>
      <button class="close-button" (click)="closeWithdrawConfirm()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content">
      <div class="confirm-message">
        <i class="fas fa-info-circle info-icon"></i>
        <p>{{ 'form.list.withdraw_warning' | translate }}</p>
      </div>

      <div class="dialog-buttons">
        <button class="cancel-button" (click)="closeWithdrawConfirm()" [disabled]="isLoading">
          {{ 'form.list.cancel' | translate }}
        </button>
        <button class="confirm-button withdraw-confirm-btn" (click)="confirmWithdraw()" [disabled]="isLoading">
          <span *ngIf="isLoading">{{ 'form.list.withdrawing' | translate }}</span>
          <span *ngIf="!isLoading">{{ 'form.list.confirm_withdraw_button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Abolish Confirmation Dialog -->
<div *ngIf="showAbolishConfirm" class="confirm-dialog-overlay">
  <div class="confirm-dialog">
    <div class="dialog-header">
      <h3>{{ 'form.list.confirm_abolish' | translate }}</h3>
      <button class="close-button" (click)="closeAbolishConfirm()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content">
      <div class="confirm-message">
        <i class="fas fa-exclamation-circle warning-icon"></i>
        <p>{{ 'form.list.abolish_warning' | translate }}</p>
      </div>

      <!-- 廢止原因輸入欄位 -->
      <div class="form-group">
        <label for="abolishReason">{{ 'form.list.abolish_reason_label' | translate }}</label>
        <textarea
          id="abolishReason"
          [(ngModel)]="abolishReason"
          rows="3"
          [placeholder]="'form.list.abolish_reason_placeholder' | translate"
          [disabled]="isLoading"
          style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
        </textarea>
      </div>

      <div class="dialog-buttons">
        <button class="cancel-button" (click)="closeAbolishConfirm()" [disabled]="isLoading">
          {{ 'form.list.cancel' | translate }}
        </button>
        <button class="confirm-button" (click)="confirmAbolish()" [disabled]="isLoading">
          <span *ngIf="isLoading">{{ 'form.list.abolishing' | translate }}</span>
          <span *ngIf="!isLoading">{{ 'form.list.confirm_abolish_button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Dialog -->
<div *ngIf="showDeleteConfirm" class="confirm-dialog-overlay">
  <div class="confirm-dialog">
    <div class="dialog-header">
      <h3>{{ 'form.list.confirm_delete' | translate }}</h3>
      <button class="close-button" (click)="closeDeleteConfirm()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content">
      <div class="confirm-message">
        <i class="fas fa-exclamation-triangle warning-icon"></i>
        <p>{{ 'form.list.delete_warning' | translate }}</p>
      </div>

      <div class="dialog-buttons">
        <button class="cancel-button" (click)="closeDeleteConfirm()" [disabled]="isLoading">
          {{ 'form.list.cancel' | translate }}
        </button>
        <button class="confirm-button" (click)="confirmDelete()" [disabled]="isLoading">
          <span *ngIf="isLoading">{{ 'form.list.deleting' | translate }}</span>
          <span *ngIf="!isLoading">{{ 'form.list.confirm_delete_button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Record Dialog -->
<div *ngIf="showAddRecordDialog" class="form-dialog-overlay">
  <div class="form-dialog">
    <div class="dialog-header">
      <h3>{{ formName }} - {{ 'form.list.add_record' | translate }}</h3>
      <button class="close-button" (click)="closeAddRecordDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <!-- Use dynamic form component, pass necessary parameters -->
      <app-dynamic-form
        [getuseridlist]="true"
        [formName]="formName"
        [formid]="formId"
        [parent_formid]="parentFormId"
        [parentDateRange]="parentDateRange"
        (recordAdded)="onRecordAdded()"
        (dataCreated)="onDataCreated($event)"
        [style.width]="'100%'"
      ></app-dynamic-form>
    </div>
  </div>
</div>

<!-- Edit Form Configuration Dialog -->
<div *ngIf="showEditFormDialog" class="fullscreen-dialog">
  <div class="dialog-header">
    <h3>{{ 'form.list.edit_form_title' | translate }} - {{ editingFormConfig?.formName }}</h3>
    <div class="header-actions">
      <button class="close-button" (click)="closeEditFormDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="dialog-content scrollable-content">
    <div class="edit-form-placeholder">
      <div class="ai-chat-container">
        <div class="chat-messages">
          <div *ngFor="let message of editFormAiMessages" class="message" [class]="message.role">
            <div class="message-content" [innerHTML]="message.content | translate"></div>
          </div>
        </div>

        <div class="chat-input-container">
          <div class="input-wrapper">
            <textarea
              [(ngModel)]="editFormAiMessage"
              (keydown)="onEditFormKeyDown($event)"
              (input)="autoResizeEditFormInput($event)"
              placeholder="{{ 'form.list.ai_input_placeholder' | translate }}"
              class="chat-input"
              rows="1"
              [disabled]="isEditFormSending">
            </textarea>
            <button
              (click)="askEditFormAi()"
              class="send-button"
              [disabled]="isEditFormSending || (!editFormAiMessage.trim())">
              <i class="fas fa-paper-plane" *ngIf="!isEditFormSending"></i>
              <i class="fas fa-spinner fa-spin" *ngIf="isEditFormSending"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Column Settings Dialog -->
<div *ngIf="showColumnSettings" class="column-settings-overlay" (click)="closeColumnSettings()">
  <div class="column-settings-dialog" (click)="$event.stopPropagation()" (keydown.escape)="closeColumnSettings()">
    <div class="dialog-header">
      <h3 tabindex="0">{{ 'form.list.column_settings_title' | translate }}</h3>
      <button class="close-button" (click)="closeColumnSettings()" [attr.aria-label]="'form.list.cancel_settings' | translate">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content">
      <!-- Column Visibility Settings -->
      <div class="settings-section">
        <h4>{{ 'form.list.column_visibility' | translate }}</h4>
        <p class="section-description">{{ 'form.list.select_columns' | translate }}</p>

        <div class="column-checkboxes">
          <div *ngFor="let column of availableColumns" class="column-checkbox-item">
            <label class="checkbox-label">
              <input type="checkbox"
                     [checked]="isColumnVisible(column)"
                     (change)="toggleColumnVisibility(column)">
              <span class="checkmark"></span>
              <span class="column-name">{{ getColumnDisplayName(column) }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Column Order Settings -->
      <div class="settings-section">
        <h4>{{ 'form.list.column_order' | translate }}</h4>
        <p class="section-description">{{ 'form.list.drag_to_reorder' | translate }}</p>

        <div class="column-reorder-list"
             cdkDropList
             (cdkDropListDropped)="dropColumn($event)">
          <div *ngFor="let column of getOrderedAvailableColumns()"
               class="column-reorder-item"
               cdkDrag
               [class.disabled]="!isColumnVisible(column)">
            <div class="drag-handle" cdkDragHandle>
              <i class="fas fa-grip-vertical"></i>
            </div>
            <span class="column-name">{{ getColumnDisplayName(column) }}</span>
            <span class="visibility-indicator"
                  [class.visible]="isColumnVisible(column)"
                  [class.hidden]="!isColumnVisible(column)">
              <i class="fas fa-eye" *ngIf="isColumnVisible(column)"></i>
              <i class="fas fa-eye-slash" *ngIf="!isColumnVisible(column)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button class="btn btn-secondary" (click)="resetColumnSettings()">
        <i class="fas fa-undo"></i>
        {{ 'form.list.reset_columns' | translate }}
      </button>
      <div class="footer-actions">
        <button class="btn btn-outline-secondary" (click)="cancelColumnSettings()">
          {{ 'form.list.cancel_settings' | translate }}
        </button>
        <button class="btn btn-primary" (click)="applyColumnSettingsAndClose()">
          {{ 'form.list.apply_settings' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Dynamic API Table Data Display Dialog -->
<div *ngIf="showDynamicApiTableDialog" class="form-dialog-overlay">
  <div class="form-dialog large-dialog">
    <div class="dialog-header">
      <h3>{{ dynamicApiTableDialogTitle }}</h3>
      <button class="close-button" (click)="closeDynamicApiTableDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <div *ngIf="dynamicApiTableData.length === 0" class="no-data-message">
        <i class="fas fa-info-circle"></i>
        <p>{{ 'form.list.no_data_display' | translate }}</p>
      </div>

      <div *ngIf="dynamicApiTableData.length > 0" class="dynamic-api-table-container">
        <table class="table">
          <thead>
            <tr>
              <th *ngFor="let column of dynamicApiTableColumns">
                {{ getColumnDisplayName(column) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dynamicApiTableData">
              <td *ngFor="let column of dynamicApiTableColumns">
                {{ getDisplayValueForTableCell(item[column]) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Meeting Signature Collection Details Dialog -->
<div *ngIf="showMeetingSignatureDialog" class="form-dialog-overlay">
  <div class="form-dialog large-dialog">
    <div class="dialog-header">
      <h3>{{ meetingSignatureDialogTitle }}</h3>
      <button class="close-button" (click)="closeMeetingSignatureDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <div *ngIf="meetingSignatureData.participants.length === 0" class="no-data-message">
        <i class="fas fa-info-circle"></i>
        <p>{{ 'meeting.signature.no_participants' | translate }}</p>
      </div>

      <div *ngIf="meetingSignatureData.participants.length > 0" class="meeting-signature-container">
        <div class="signature-summary">
          <h4>{{ 'meeting.signature.statistics' | translate }}</h4>
          <p>{{ 'meeting.signature.signed_count' | translate }}: <strong>{{ meetingSignatureData.signedCount }}</strong></p>
          <p>{{ 'meeting.signature.total_count' | translate }}: <strong>{{ meetingSignatureData.totalCount }}</strong></p>
        </div>

        <div class="participants-list">
          <h4>{{ 'meeting.signature.participants_details' | translate }}</h4>
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'meeting.signature.name' | translate }}</th>
                  <th>{{ 'meeting.signature.title_field' | translate }}</th>
                  <th>{{ 'meeting.signature.department' | translate }}</th>
                  <th>{{ 'meeting.signature.signature_image' | translate }}</th>
                  <th>{{ 'meeting.signature.status' | translate }}</th>
                  <th>{{ 'meeting.signature.signed_time' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let participant of meetingSignatureData.participants"
                    [class.signed]="getSignatureImageData(participant.signature)"
                    [class.unsigned]="!getSignatureImageData(participant.signature)">
                  <td>{{ participant.name }}</td>
                  <td>{{ participant.title || '-' }}</td>
                  <td>{{ participant.department || '-' }}</td>
                  <td>
                    <!-- Display signature image -->
                    <div *ngIf="getSignatureImageData(participant.signature)" class="signature-thumbnail-container">
                      <img [src]="getSignatureImageData(participant.signature)" alt="Signature" class="signature-thumbnail-dialog"
                           [title]="participant.name + ' 的簽名'"
                           (error)="onImageError(participant.signature)"
                           (load)="onImageLoad(participant.name)">
                    </div>
                    <span *ngIf="!getSignatureImageData(participant.signature)" class="no-signature-text">
                      {{ 'meeting.signature.no_signature' | translate }}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="getSignatureImageData(participant.signature)" class="status-badge signed">
                      <i class="fas fa-check-circle"></i> {{ 'meeting.signature.signed' | translate }}
                    </span>
                    <span *ngIf="!getSignatureImageData(participant.signature)" class="status-badge unsigned">
                      <i class="fas fa-clock"></i> {{ 'meeting.signature.unsigned' | translate }}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="participant.signedAt">
                      {{ formatDate(participant.signedAt) }}
                    </span>
                    <span *ngIf="!participant.signedAt">-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Form View Popup Window -->
<div *ngIf="showViewForm" class="form-view-modal-overlay global-overlay" (click)="closeViewForm()">
  <div class="form-view-modal global-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <i class="fas fa-eye"></i>
        {{ 'form.list.view_details' | translate }} - {{ viewFormName }}
      </h3>
      <button class="close-button" (click)="closeViewForm()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div *ngIf="viewFormConfig.length === 0" class="loading-message">
        <i class="fas fa-spinner fa-spin"></i>
        {{ 'common.loading' | translate }}
      </div>

      <div *ngIf="viewFormConfig.length > 0">
        <app-form-display
          [formName]="viewFormName"
          [config]="viewFormConfig"
          [formData]="viewFormData"
          [formid]="formId"
          [recordId]="viewFormData?.id">
        </app-form-display>
      </div>
    </div>
  </div>
</div>

<!-- File Selection Modal Window -->
<div *ngIf="showFilesModal" class="modal-overlay" (click)="closeFilesModal()">
  <div class="files-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>{{ 'form.list.select_file_to_view' | translate }}</h4>
      <button class="close-button" (click)="closeFilesModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="files-summary mb-3">
        <span class="badge bg-primary">{{ modalFiles.length }} {{ 'form.list.files' | translate }}</span>
        <small class="text-muted ms-2">
          {{ 'form.list.total_size' | translate }}: {{ getTotalFileSize(modalFiles) }}
        </small>
      </div>

      <div class="files-list">
        <div *ngFor="let file of modalFiles; let i = index"
             class="file-item d-flex align-items-center p-3 mb-2 border rounded">
          <div class="file-icon me-3">
            <i class="fas fa-file-pdf text-danger" *ngIf="file?.type?.includes('pdf')"></i>
            <i class="fas fa-file-image text-success" *ngIf="file?.type?.includes('image')"></i>
            <i class="fas fa-file-word text-primary" *ngIf="file?.type?.includes('word') || file?.type?.includes('document')"></i>
            <i class="fas fa-file text-secondary" *ngIf="!file?.type || (!file?.type?.includes('pdf') && !file?.type?.includes('image') && !file?.type?.includes('word') && !file?.type?.includes('document'))"></i>
          </div>

          <div class="file-info flex-grow-1">
            <div class="file-name fw-bold">
              {{ file?.name || ('file.unnamed' | translate) + ' ' + (i + 1) }}
            </div>
            <div class="file-details text-muted small">
              <span *ngIf="file?.size">{{ formatFileSize(file.size) }}</span>
              <span *ngIf="formatUploadTime(file)" class="ms-2">
                <i class="fas fa-clock"></i>
                {{ formatUploadTime(file) }}
              </span>
            </div>
          </div>

          <button class="btn btn-primary btn-sm"
                  (click)="viewFile(file); closeFilesModal()"
                  [title]="'form.list.view_this_file' | translate">
            <i class="fas fa-eye me-1"></i>
            {{ 'form.list.view' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reference Data Dialog -->
<div *ngIf="showReferenceDataDialog" class="modal-overlay" (click)="closeReferenceDataDialog()">
  <div class="reference-data-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>{{ referenceDataDialogTitle }}</h4>
      <button class="close-button" (click)="closeReferenceDataDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div *ngIf="referenceDataContent" class="reference-data-content">
        <div *ngFor="let item of getReferenceDataItems()" class="reference-item">
          <div class="reference-field">
            <strong>{{ item.label }}:</strong>
            <span class="reference-value">
              {{ item.displayValue }}
              <small *ngIf="item.keyId" class="text-muted"> (ID: {{ item.keyId }})</small>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Radio Button Details Modal Window -->
<div *ngIf="showRadiobuttonDetailModal" class="modal-overlay" (click)="closeRadiobuttonDetails()">
  <div class="radiobutton-details-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>{{ ('radiobutton.details.title' | translate) || 'Radio Button Details' }}</h4>
      <button class="close-button" (click)="closeRadiobuttonDetails()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content" *ngIf="radiobuttonDetailData">
      <!-- Selected Value -->
      <div class="detail-section">
        <h5>{{ ('radiobutton.details.selected_value' | translate) || 'Selected Option' }}</h5>
        <p class="selected-value-text">{{ radiobuttonDetailData.selectedValue }}</p>
      </div>

      <!-- Remarks -->
      <div class="detail-section" *ngIf="radiobuttonDetailData.remarks">
        <h5>
          <i class="fas fa-comment-alt"></i>
          {{ ('radiobutton.details.remarks' | translate) || 'Remarks' }}
        </h5>
        <p class="remarks-text">{{ radiobuttonDetailData.remarks }}</p>
      </div>

      <!-- Uploaded Files -->
      <div class="detail-section" *ngIf="radiobuttonDetailData.uploadedFiles && radiobuttonDetailData.uploadedFiles.length > 0">
        <h5>
          <i class="fas fa-image"></i>
          {{ ('radiobutton.details.uploaded_files' | translate) || 'Uploaded Files' }}
        </h5>
        <div class="uploaded-files-section">
          <div class="files-grid">
            <div *ngFor="let file of radiobuttonDetailData.uploadedFiles; let i = index"
                 class="file-item">
              <div class="file-preview">
                <!-- Image Preview -->
                <img *ngIf="isImageFile(file.fileName)"
                     [src]="file.fileUrl"
                     [alt]="file.fileName"
                     class="file-image"
                     (error)="onImageError(file.fileName)"
                     (click)="openImageModal(file.fileUrl, file.fileName)">

                <!-- Non-image file icon -->
                <div *ngIf="!isImageFile(file.fileName)" class="file-icon">
                  <i class="fas fa-file-alt"></i>
                </div>
              </div>

              <div class="file-info">
                <span class="file-name" [title]="file.fileName">{{ file.fileName }}</span>
                <div class="file-actions">
                  <button class="btn-download"
                          (click)="downloadFile(file.fileUrl, file.fileName)"
                          [title]="'common.download_file' | translate">
                    <i class="fas fa-download"></i>
                  </button>
                  <button class="btn-view"
                          (click)="viewFile(file)"
                          [title]="'common.view_file' | translate">
                    <i class="fas fa-eye"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Audio Recording File -->
      <div class="detail-section" *ngIf="radiobuttonDetailData.audioRecording">
        <h5>
          <i class="fas fa-microphone"></i>
          {{ ('radiobutton.details.audio_recording' | translate) || 'Audio Recording' }}
        </h5>
        <div class="audio-section">
          <div class="audio-info">
            <span class="audio-filename">{{ radiobuttonDetailData.audioRecording.fileName }}</span>
            <span class="audio-duration" *ngIf="radiobuttonDetailData.audioRecording.duration">
              ({{ radiobuttonDetailData.audioRecording.duration }}{{ 'common.seconds' | translate }})
            </span>
          </div>
          <!-- Audio playback controls -->
          <div class="audio-controls" *ngIf="radiobuttonDetailData.audioRecording.fileUrl">
            <audio [src]="radiobuttonDetailData.audioRecording.fileUrl"
                   controls
                   preload="metadata"
                   style="max-width: 100%;">
              {{ 'audio.browser_not_supported' | translate }}
            </audio>
          </div>
        </div>
      </div>

      <!-- Complete Text -->
      <div class="detail-section" *ngIf="radiobuttonDetailData.completeText">
        <h5>{{ ('radiobutton.details.complete_text' | translate) || 'Complete Data' }}</h5>
        <pre class="complete-text">{{ radiobuttonDetailData.completeText }}</pre>
      </div>
    </div>
  </div>
</div>

<!-- Email Confirmation Popup -->
<app-email-confirmation-modal
  [show]="showEmailConfirmationModal"
  [emails]="emailPreviewData"
  [title]="'contractor_management.menu.construction_application' | translate"
  [constructionInfo]="pendingConstructionInfo"
  (confirmed)="onEmailConfirmationResult($event)"
  (cancelled)="onEmailConfirmationResult({ confirmed: false, emails: [], action: 'cancel' })"
  (modalClosed)="onEmailConfirmationModalClosed()">
</app-email-confirmation-modal>

<!-- 🆕 待辦事項清單彈窗 -->
<div class="modal todo-modal" *ngIf="showTodoListModal" (click)="closeTodoListModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">待辦事項清單</h4>
        <button type="button" class="close" (click)="closeTodoListModal()">
          <span>&times;</span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="todo-list" *ngIf="currentTodoInfo && currentTodoInfo.todos.length > 0">
          <div class="todo-item" *ngFor="let todo of currentTodoInfo.todos">
            <span class="todo-icon">{{ todo.icon }}</span>
            <span class="todo-description">{{ todo.description }}</span>
          </div>
        </div>

        <div class="no-todos" *ngIf="!currentTodoInfo || currentTodoInfo.todos.length === 0">
          <i class="fas fa-check-circle success-icon"></i>
          <p>所有必要項目都已完成！</p>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <p class="help-text">請到編輯頁面處理待辦事項</p>
        <button type="button" class="btn btn-secondary" (click)="closeTodoListModal()">
          關閉
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Form Info Modal -->
<div *ngIf="showFormInfoModal" class="modal-overlay" (click)="closeFormInfo()">
  <div class="form-info-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>{{ 'form.list.form_information' | translate }}</h4>
      <button class="close-button" (click)="closeFormInfo()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="info-item">
        <label>{{ 'form.list.form_name' | translate }}:</label>
        <span>{{ formName }}</span>
      </div>
      <div class="info-item">
        <label>{{ 'form.list.form_id' | translate }}:</label>
        <span class="form-id">{{ formId }}</span>
      </div>
    </div>
  </div>
  </div> <!-- 關閉 hasAnyPermission() 的 div -->
</div>
